import { render, staticRenderFns } from "./tourMenu.vue?vue&type=template&id=7c755d6d"
import script from "./tourMenu.vue?vue&type=script&lang=js"
export * from "./tourMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports